export const formatLessThan10 = (n: number): string => {
  if (n === 0) return '0';
  if (n < 10) {
    return `0${n}`;
  }
  return `${n}`;
};
